/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { type AvailableVehicle } from '../../api/data/AvailableVehicle'
import { type ConfigVehicleData } from '../../api/data/ConfigResponse'
import { useGenerateAvailability } from '../../api/hooks'
import { type VehicleCard } from '../../api/interfaces'
import { getConfig } from '../../services/config-service'
import { associatedVehiclesAction, enterCustomerInfoAction } from '../../store/reservationSlice'
import { type RootState } from '../../store/store'
import { PRICE_MATRIX, dateTimeDiff, getPriceMatrix } from '../../utils'
import UnitCard from '../elements/UnitCard/UnitCard'
import styles from './VehicleTab.module.scss'

const VehicleTab = (): any => {
  const reservation = useSelector((state: RootState) => state.reservationSlice.reservation)

  const associatedVehicles: undefined | AvailableVehicle = useSelector((state: RootState) => state.reservationSlice.associatedVehicles)
  const dispatch = useDispatch()

  const [selectedUnit, setSelectedUnit] = useState<number | null>(reservation?.modelGroupIndex ?? null)
  const [customeError, setCustomeError] = useState<string | null>(null)

  const handleOnSelect = (unitId: number): void => {
    setSelectedUnit(unitId)
  }

  const refresh = typeof associatedVehicles?.results === 'undefined'

  const { isLoading, error, vehicles } = useGenerateAvailability(reservation, refresh)
  const [configVehicleData, setVehicleData] = useState<ConfigVehicleData[]>([])
  const configValue = getConfig<ConfigVehicleData[]>('webschedulerModelGroup', false)

  useEffect(() => {
    if (vehicles && vehicles?.statusCode === 200 && vehicles?.data?.results && vehicles?.data?.results > 0) {
      dispatch(associatedVehiclesAction(vehicles.data))
    }

    setVehicleData(configValue ?? [])
  }, [vehicles])

  const vehicleCards: VehicleCard[] = []

  const dateDiff = dateTimeDiff(reservation?.pickupDateTime, reservation?.dropOffDateTime)
  const priceMatrixOriginal = getPriceMatrix(dateDiff?.days, dateDiff?.hours)

  if (associatedVehicles?.availableItems && configVehicleData) {
    const modelGroupCount = associatedVehicles?.availableItems?.length
    let priceMatrix = priceMatrixOriginal // initialize
    for (let index = 0; index < modelGroupCount; index++) {
      const element: any = associatedVehicles?.availableItems[index]
      const config = configVehicleData.find((x) => x.Name.toLowerCase() === element?.modelGroup?.name.toLowerCase())
      if (
        element.rates.length > 0 &&
        priceMatrix &&
        !element.rates[0][priceMatrix.key] &&
        (priceMatrix === PRICE_MATRIX.HOURLY || priceMatrix === PRICE_MATRIX.WEEKLY)
      ) {
        // if no hourly/weekly rate, then bump it up to daily
        priceMatrix = PRICE_MATRIX.DAILY
      }

      vehicleCards.push({
        description: config?.Description ?? '',
        image: config?.ImagePath ?? '',
        model: element?.modelGroup?.name,
        price: element.rates.length > 0 && priceMatrix ? element.rates[0][priceMatrix.key] : 0,
        key: index,
        rateCode: element.rates.length > 0 ? element.rates[0].rateCode : '',
        pricePer: priceMatrix?.display ? priceMatrix?.display : ''
      })

      priceMatrix = priceMatrixOriginal // reset
    }
  }

  async function handleNext(): Promise<void> {
    const updatedReservation = {
      ...reservation
    }
    if (selectedUnit != null) {
      const selectedVehicle = vehicleCards.find((v) => v.key === selectedUnit)
      updatedReservation.modelGroup = selectedVehicle?.model
      updatedReservation.rateCode = selectedVehicle?.rateCode
      updatedReservation.modelGroupIndex = selectedUnit ?? 0
      updatedReservation.modelGroupImage = selectedVehicle?.image
      setCustomeError(null)
      dispatch(enterCustomerInfoAction(updatedReservation))
    } else {
      setCustomeError('Select a vehicle.')
    }
  }

  const unitCards = vehicleCards.map((item, index) => (
    <UnitCard
      key={index}
      id={index}
      model={item.model}
      price={item.price}
      pricePer={item.pricePer}
      image={item.image}
      selected={selectedUnit}
      description={item.description}
      selectUnit={handleOnSelect}
    />
  ))
  return (
    <div className={styles.VehicleTab} data-testid='VehicleTab'>
      {vehicles.errorMessage || error || customeError ? <p className='errorMessage'>{vehicles.errorMessage || error || customeError}</p> : ''}
      {isLoading && unitCards ? <p>Loading...</p> : <div className='UnitCardContainer'>{unitCards}</div>}
      <button disabled={false} className='button primary float-right expanded' data-testid='Button' onClick={handleNext} type='submit'>
        {'NEXT'}
      </button>
    </div>
  )
}

export default VehicleTab
